module.exports = __webpack_public_path__ + "img/house.1b03c446.svg";